/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Partial_TCreateCreditPackageRequest_ } from '../models/Partial_TCreateCreditPackageRequest_';
import type { TCreateCreditCheckoutRequest } from '../models/TCreateCreditCheckoutRequest';
import type { TCreateCreditCheckoutResponse } from '../models/TCreateCreditCheckoutResponse';
import type { TCreateCreditPackageRequest } from '../models/TCreateCreditPackageRequest';
import type { TCreditPackageId } from '../models/TCreditPackageId';
import type { TCreditPackageResponse } from '../models/TCreditPackageResponse';
import type { TListCreditPackagesResponse } from '../models/TListCreditPackagesResponse';
import type { TListCreditPurchasesResponse } from '../models/TListCreditPurchasesResponse';
import type { TTalentManagerEngagementId } from '../models/TTalentManagerEngagementId';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreditsService {
    /**
     * List available credit packages
     * @returns TListCreditPackagesResponse Ok
     * @throws ApiError
     */
    public static listCreditPackages(): CancelablePromise<TListCreditPackagesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/credits/packages',
        });
    }
    /**
     * Create a credit package (admin only)
     * @param requestBody
     * @returns TCreditPackageResponse Ok
     * @throws ApiError
     */
    public static createCreditPackage(
        requestBody: TCreateCreditPackageRequest,
    ): CancelablePromise<TCreditPackageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/credits/packages',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List all credit packages, including inactive ones (admin only)
     * @returns TListCreditPackagesResponse Ok
     * @throws ApiError
     */
    public static listAllCreditPackages(): CancelablePromise<TListCreditPackagesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/credits/packages/admin/all',
        });
    }
    /**
     * Update a credit package (admin only)
     * @param id
     * @param requestBody
     * @returns TCreditPackageResponse Ok
     * @throws ApiError
     */
    public static updateCreditPackage(
        id: TCreditPackageId,
        requestBody: Partial_TCreateCreditPackageRequest_,
    ): CancelablePromise<TCreditPackageResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/credits/packages/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a credit package (admin only)
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteCreditPackage(
        id: TCreditPackageId,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/credits/packages/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create a Stripe Checkout session for purchasing credits
     * @param requestBody
     * @returns TCreateCreditCheckoutResponse Ok
     * @throws ApiError
     */
    public static createCreditCheckout(
        requestBody: TCreateCreditCheckoutRequest,
    ): CancelablePromise<TCreateCreditCheckoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/credits/checkout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List credit purchases for an engagement
     * @param engagementId
     * @returns TListCreditPurchasesResponse Ok
     * @throws ApiError
     */
    public static listCreditPurchases(
        engagementId: TTalentManagerEngagementId,
    ): CancelablePromise<TListCreditPurchasesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/credits/purchases',
            query: {
                'engagementId': engagementId,
            },
        });
    }
}
